import Header from "../layout/Header";
import Footer from "../layout/Footer";
import { useNavigate } from "react-router-dom";
import SEO from "../SEO/SEO"

const ProductsPage = () => {
  const productCategories = [
    {
      title: "Our Core Products",
      description:
        "We specialize in providing high-quality industrial solutions tailored to meet your manufacturing needs with reliability and precision.",
      items: [
        "Industrial Machinery & Equipment",
        "Spare Parts & Components",
        "Precision Tools & Instruments",
        "Customized Solutions",
        "Maintenance & Support",
        "Technical Consultation",
      ],
    },
  ];

  const features = [
    {
      icon: "✓",
      title: "Quality Assured",
      description: "Rigorously tested equipment from trusted sources",
    },
    {
      icon: "💰",
      title: "Best Value",
      description: "Competitive pricing without compromising quality",
    },
    {
      icon: "🚚",
      title: "Fast Delivery",
      description: "Efficient logistics for timely order fulfillment",
    },
    {
      icon: "🔧",
      title: "Expert Support",
      description: "Technical guidance and after-sales service",
    },
  ];
  const navigate = useNavigate();
  const handleContact = () => navigate("/contact");
  return (
    <>
      <Header />
      <SEO
        title="Products | Nexora Machinery"
        description="Learn about Nexora Machinery, a trusted supplier of CNC Turning Centers, VMC Machines, Milling Machines, Tapping Machines and industrial machinery."
        keywords="About Nexora Machinery, CNC Machine Supplier"
        path="/products"
      />
      <section className="relative bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 text-white pt-24 pb-20">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-6xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
            Our <span className="text-cyan-400">Products</span>
          </h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto mb-6">
            Premium Industrial Solutions & Equipment
          </p>
          <div className="w-20 h-1 bg-cyan-400 mx-auto"></div>
        </div>
      </section>
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <span className="text-cyan-600 font-semibold text-sm uppercase tracking-wide">
              What We Offer
            </span>
            <h2 className="text-3xl font-bold text-slate-800 mt-2 mb-4">
              Our Product Solutions
            </h2>
            <p className="text-slate-600 max-w-2xl mx-auto">
              Delivering comprehensive industrial solutions through quality
              products and expert support
            </p>
          </div>
          {productCategories.map((category, index) => (
            <div key={index} className="bg-slate-50 rounded-2xl p-6 md:p-8">
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-slate-800 mb-3">
                  {category.title}
                </h3>
                <p className="text-slate-600 max-w-3xl mx-auto">
                  {category.description}
                </p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {category.items.map((item, itemIndex) => (
                  <div
                    key={itemIndex}
                    className="bg-white rounded-xl p-4 shadow-sm border border-slate-200 hover:shadow-md transition-all duration-300 hover:border-cyan-200"
                  >
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 bg-cyan-500 rounded-lg flex items-center justify-center flex-shrink-0">
                        <span className="text-white text-sm font-bold">✓</span>
                      </div>
                      <span className="text-slate-800 font-medium">{item}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
      <section className="py-16 bg-slate-50">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <span className="text-cyan-600 font-semibold text-sm uppercase tracking-wide">
              Why Choose Us
            </span>
            <h2 className="text-3xl font-bold text-slate-800 mt-2 mb-4">
              Our Commitment
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map((feature, index) => (
              <div key={index} className="text-center group">
                <div className="w-16 h-16 bg-slate-800 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:bg-cyan-600 transition-colors duration-300">
                  <span className="text-white text-xl">{feature.icon}</span>
                </div>
                <h3 className="text-lg font-bold text-slate-800 mb-2">
                  {feature.title}
                </h3>
                <p className="text-slate-600 text-sm">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="py-16 bg-slate-800 text-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to Get Started?</h2>
          <p className="text-slate-300 text-lg mb-8 max-w-2xl mx-auto">
            Contact us for product inquiries, pricing, and technical
            specifications. Let's find the perfect solution for your needs.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {/* <button className="bg-cyan-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-cyan-600 transition-colors duration-300 transform hover:scale-105">
              Get Pricing
            </button> */}
            <button
              onClick={handleContact}
              className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-slate-800 transition-all duration-300"
            >
              Contact Sales
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default ProductsPage;
